export const ApplicationEN = {
    "applications": {
        "headingLabel": "Application",
        "list": "All applications",
        "reason": "Reason",
        "paid": "Paid",
        "owner": "Owner applications",
        "approval": "Approved applications",
        "department": "Department applications",
        "forElse": "For someone else",
        "information": "General information",
        "generalInformation": "General information",
        "detail": "Detail",
        employeeApproval: "Employee Approval",
        message: {
            error: {
                description: "Description is required",
                employee: "Employee is required",
            }
        },
        "status": {
            "pending": "Pending",
            "approved": "Approved",
            "all": "All",
            "reject": "Reject",
            "draft": "Draft",
            "expired": "Expired",
            "inactive": "Inactive",
            "incomplete": "Incomplete",
            "denied": "Denied"
        },
        "label": {
            "fullName": "Full name",
            "department": "Department",
            "jobPosition": "Job position",
            "jobTitle": "Job title",
            "status": "Status",
            "approve": "Approve",
            "description": "Description",
            "actionSend": {
                "add": "Add and Send",
                "update": "Update and Send"
            }
        },
        "columns": {
            "creator": "Creator",
            "employeeCode": "Employee code",
            "fullName": "Full name",
            "status": "Status",
            "type": "Type",
            "department": "Department",
            "position": "Position",
            "dateCreated": "Date created"
        },
        "rules": {
            "reason": "Reason not provided"
        },
        "placeholder": {
            "reason": "Choose reason",
            "hour": "hh:mm",
            "date": "DD-MM-YYYY",
            employee: "Select Employee",
            description: "Enter description"
        },
        attach: "Attach",
        "type": {
            "inout": {
                "headingLabel": "Check in check out",
                "ownerId": "Owner",
                "ownerIds": "Owners",
                "forElse": {
                    "headingLabel": "Check in check out for someone else"
                },
                "addNew": "Add new check in check out",
                "update": "Update check in check out",
                "information": "Information",
                "date": "Date",
                "hour": "Hour",
                "noShift": "No shift-registration",
                "shift": "Shift",
                "reason": "Reason",
                "penalty": "Penalty",
                "description": "Description",
                "maximum": "Maximum",
                "detail": "Detail check in check out",
                "createMultiEmployees": "Create for multi employees",
                "placeholder": {
                    "date": "Choose date",
                    "time": "Choose time",
                    "chooseReason": "Choose reason",
                    "ownerIds": "Choose employees",
                    "ownerId": "Choose employee"
                },
                "option": {
                    "yes": "Yes",
                    "no": "No",
                    "unit/week": "unit/week",
                    "units/week": "units/week",
                    "unit/month": "unit/month",
                    "units/month": "units/month",
                    "unit/year": "unit/year",
                    "units/year": "units/year"
                },
                "columnsDetail": {
                    "date": "Date",
                    "time": "Time",
                    "reason": "Reason",
                    "fine": "Fine"
                },
                "validate": {
                    "date": "Date is required",
                    "hour": "Hour is required",
                    "reason": "Reason is required",
                    "ownerId": "Owner is required"
                }
            },
            "flexible": {
                "headingLabel": "Flexible",
                "forElse": {
                    "headingLabel": "Flexible for someone else"
                },
                fromDate: "From date",
                toDate: "To date",
                "infomation": "Detail menu follow the mode",
                "flexibleAdd": "Add custom order form",
                "flexibleEdit": "Edit application according to the mode ",
                "flexibleList": "List of menus by mode",
                "flexibleDelete": "Delete order by mode",
                "reason": "Reason",
                "day1": "Since",
                "day2": "To date",
                "late": "Late",
                "total": "Total hours",
                "backSoon": "Come back soon",
                "description": "Describe",
                "employeeApplicationFlexible": "Personnel need to create an application",
                "flexibleInOut": "Tardiness leave early",
                "flexibleTime": "Time",
                "enterReason": "Choose a reason",
                "enterADescription": "Enter a description",
                "adSuccess": "Add order by success mode!",
                "updateSuccess": "Editing order information according to the success mode!",
                "deleteSuccess": "Delete order by success mode!"
            },
            "shiftRegistration": {
                "headingLabel": "Shift Registration",
                "headingDetailLabel": "Shift Registration Details",
                "addNew": "Create New Shift Registration",
                "update": "Update Shift Registration",
                "detail": "Shift Registration Details",
                "forElse": {
                    "headingLabel": "Create Overtime Request for Others"
                },
                "typeShift": {
                    "range": "By Date Range",
                    "fixed": "By Fixed Date"
                },
                "currentShift": "Assigned Shift",
                "requestShift": "Requested Overtime Shift",
                "date": "Overtime Date",
                "type": "Type",
                "attendance": "Attendance Request",
                "placeholder": {
                    "date": "DD/MM/YYYY",
                    "shiftNeedChange": "Enter shift to change",
                    "shiftWantChange": "Enter desired shift",
                    "personChange": "Enter person to swap with"
                },
                "dayShiftOfWeek": {
                    "monday": "Monday",
                    "tuesday": "Tuesday",
                    "wednesday": "Wednesday",
                    "thursday": "Thursday",
                    "friday": "Friday",
                    "saturdayOdd": "Even Saturday",
                    "saturdayEven": "Odd Saturday",
                    "sunday": "Sunday"
                }
            },
            "resign": {
                "headingLabel": "Resign",
                "forElse": {
                    "headingLabel": "Resign for someone else"
                },
                "add": "Create a new resignation application",
                update: "Update a new resignation application",
                "detailInformation": "Details",
                "placeholder": {
                    "reason": "Select reason",
                    "resignationDate": "DD/MM/YYYY",
                    "description": "Enter a description",
                    "relateObject": "Select objects",
                    "record": "Select record",
                    "employee": "Select",
                    address: "Select Address"
                },
                "label": {
                    "reason": "Reason",
                    "resignationDate": "Resignation date",
                    "description": "Description",
                    "relateObject": "Related objects",
                    "record": "Record",
                    "heading": "Resignation application",
                    "employee": "Create for",
                    "name": "Name",
                    "department": "Department",
                    "jobPosition": "Job Position",
                    "jobTitle": "Job Title",
                    "pending": "Pending",
                    "approved": "Approved",
                    "work": "Work",
                    "project": "Project"
                },
                "rule": {
                    "reason": "Please select the reason!",
                    "resignationDate": "Please enter the resignation date!",
                    "employee": "Create for filed is required"
                }
            },
            "shiftChange": {
                "detail": "Shift change detail",
                "headingLabel": "Shift change",
                "addNew": "Create new shift-registration change",
                "forElse": {
                    "headingLabel": "Shift change for someone else"
                },
                "update": "Update shift-registration change",
                "typeShiftChange": "Type shift-registration change",
                "differentTime": "Create with different times",
                "employeeNeedApplication": "Employee need create application",
                "chooseType": "Choose type",
                "myself": "Myself",
                "others": "Others",
                "dayNeedChange": "Date need change",
                "shiftNeedChange": "Shift need change",
                "dateChange": "Date change",
                "personChange": "Changer",
                "shiftWantChange": "Shift want change",
                "placeholder": {
                    "date": "DD-MM-YYYY",
                    "shiftNeedChange": "Type shift-registration need change",
                    "shiftWantChange": "Type shift-registration want change",
                    "personChange": "Type changer",
                    "employeeNeedApplication": "Type employee need create application"
                },
                "columnsDetail": {
                    "dateChange": "Date change",
                    "appOwnerId": "Owner",
                    "dateWant": "Date want",
                    "shiftWant": "Shift want"
                },
                "required" :{
                    "dayrequired" : "Shift change date is a mandatory field",
                    "shift1" : "The shift to be changed is a mandatory field",
                    "dayrequired2" : "Change date is required field",
                    "employeeChange" : "Changer is a required field" ,
                    "shift2" : "The shift you want to change is a mandatory field"
                }
            },
            "missions": {
                "headingLabel": "Mission",
                "addMission": "Create an application missions",
                updateMission: "Update an application missions",
                "forElse": {
                    "headingLabel": "Mission for someone else"
                },
                "detailInformation": "Details",
                "placeholder": {
                    "reason": "Select reason missions",
                    "resignationDate": "DD-MM-YYYY",
                    "description": "Enter a description",
                    "relateObject": "Select objects",
                    "record": "Select record",
                    "employee": "Select",
                    "address": "Enter the address",
                    "missionVehicle": "Select vehicle",
                    "sum": "Sum",
                    "missionFee": "Travel expenses, cost of meal, etc",
                    "domestic": "Domestic",
                    "oversea": "Oversea",
                    "from": "From",
                    "to": "To",
                    "vehicle" : "Vehicle"
                },
                "label": {
                    "reason": "Reason",
                    "description": "Content",
                    "relateObject": "Related objects",
                    "record": "Record",
                    "heading": "Mission application",
                    "employee": "Create for",
                    "name": "Name",
                    "department": "Department",
                    "jobPosition": "Job Position",
                    "jobTitle": "Job Title",
                    "pending": "Pending",
                    "approved": "Approved",
                    "work": "Work",
                    "project": "Project",
                    "startTime": "Start time",
                    "endTime": "End time",
                    "startDate": "Start date",
                    "endDate": "End date",
                    "address": "Address",
                    "missionVehicle": "Vehicle",
                    "typeOversea": "Type",
                    "oversea": "Overseas business trip",
                    "missionFee": "Additional fee",
                    "missionFeeName": "Name",
                    "missionFeeAmount": "Amount",
                    "sum": "Total fee"
                },
                "rule": {
                    "reason": "Please select the missions reason!",
                    "employee": "Create for filed is required",
                    "address": "Address field is required",
                    "startTime": "Start time field is required",
                    "endTime": "End time field is required",
                    "startDate": "Start date field is required",
                    "endDate": "End date field is required",
                    "content": "Content field is required"
                }
            },
            "overtime": {
                "headingLabel": "Application for overtime",
                "addNew": "Create a new job application form",
                "update": "Update overtime application",
                "detail": "Details of overtime application",
                "forElse": {
                    "headingLabel": "Create a job application for someone else"
                },
                message: {
                    error: {
                        fromTime: "From Time is required",
                        toTime: "To Time is required"
                    }
                },
                "day": "Overtime days",
                "fromDay": "From now",
                "toDay": "It's time",
                "shiftId": "Shift",
                "type": "Type",
                "latch": "Latches",
                "time": "Overtime",
                "total" : "Total hours",
                "note" : "Note"
            },
            "shiftMore": {
                "headingLabel": "Shift More",
                "addNew": "Create new shift more",
                "update": "Update shiftmore",
                "detail": "Detail shiftmore",
                "forElse": {
                    "headingLabel": "Shift change for someone else"
                },
                "typeShiftChange": "Type shift-registration change",
                "chooseType": "Choose type",
                "myself": "Myself",
                "others": "Others",
                "dayNeedChange": "Date need change",
                "shiftNeedChange": "Shift need change",
                "dateChange": "Date change",
                "personChange": "Changer",
                "shiftWantChange": "Shift want change",

                "currentShift": "Current Shift",
                "requestShift": "Request Shift",
                "date": "Date",
                "type": "Type",
                "attendance": "Attendance",

                message: {
                    error: {
                        date: "Compulsory overtime date to choose"
                    }
                },
                "placeholder": {
                    "date": "DD-MM-YYYY",
                    "shiftNeedChange": "Type shift-registration need change",
                    "shiftWantChange": "Type shift-registration want change",
                    "personChange": "Type changer"
                }
            },
            "leave": {
                "headingLabel": "Leave application",
                "addNew": "Create new leave application",
                "update": "Update leave application",
                "startHour": "Start hour",
                "detail": "Detail leave application",
                "endHour": "End hour",
                "startDate": "Start date",
                "endDate": "End date",
                "isRequired": "is required",
                "timeAdd": "Time add",
                "used": "Used",
                "canLeave": "Can leave",
                "canAdvance": "Can advance",
                "residualLeave": "Residual leave",
                "shift": "Shift work",
                "firstHalfShift": "First half shift work",
                "lastHalfShift": "Last half shift work",
                "option": {
                    "day/year": "day/year",
                    "day/month": "day/month",
                    "day/week": "day/week",
                    "days/year": "days/year",
                    "days/month": "days/month",
                    "days/week": "days/week"
                },
                "forElse": {
                    "headingLabel": "Create leave application for else"
                },
                "columnsDetail": {
                    "startDate": "Start date",
                    "endDate": "End date",
                    "duration": "Duration",
                    "timeByShift": "Time by shift-registration"
                },
                "unit": {
                    "date": "Date",
                    "minute": "Minute",
                    "hour": "Hour"
                },
                "validate": {
                    "date": "Chưa nhập ngày",
                    "hour": "Chưa nhập giờ",
                    "reason": "Chưa chọn lý do",
                    "ownerId": "Chưa nhập nhân viên cần tạo đơn"
                },
                "placeholder": {
                    "reason": "Select reason",
                    "shift": "Seleact shift work",
                    "description": "Description"
                }
            },
            "shift": {
                "headingLabel": "Application Shift",
                "detailInformation": "Details",
                "forElse": {
                    "headingLabel": "Shift for someone else"
                },
                "label": {
                    "type": "Type",
                    "date": "Date",
                    "shift": "Shift",
                    "detailShift": "Details",
                    "detailApp": "Title",
                    "detail": "Details",
                    "description": "Description",
                    "dateTable": "Date",
                    "shiftTable": "Shift",
                    "totalHour": "Total Hours",
                    "hour": "hour",
                    "minute": "minute"
                },
                "placeholder": {
                    "startDate": "Select start date",
                    "endDate": "Select end date",
                    "shift": "Select shift-registration..."
                },
                "typeShift": {
                    "range": "By interval date",
                    "fixed": "By fixed date"
                }
            },
            "absence": {
                "update": "Update application",
                "addAbsence": "Create an application absence ",
                "forElse": {
                    "headingLabel": "Create an absentee application for someone else"
                },
                "label":{
                    "dayOff" : "Day off",
                    "fromNow" : "From now",
                    "toNow" : "To now",
                    "reason" : "Reason for absence",
                    "workCalculation" : "Work calculation",
                    "closingRequest" : "Closing request",
                    "description" : "Description",
                    "relatedObjects" : "Related objects",
                    "record" : "Record",
                    "createMany" : "Create an application for many people",
                    "different" : "Singles with different time periods"
                },
                "placeholder":{
                    "yes" : "Yes",
                    "no" : "No",
                    "selectReason" : "Select reason absence"
                }
            },
            "late": {
                "type": {
                    "late": "Late",
                    "leave": "Leave",
                    "absence": "Absence"
                },
                "late": "Create an order to go late and leave early",
                "other": {
                    "late": "Create an application to go late and leave early"
                },
                "update": "Update the application for coming late and leaving early",
                "detail": "Details of the application for late arrival and early return",
                "label": {
                    "daylate" : "Days go late, come back early",
                    "shiftlate" : "Shift",
                    "from" : "From now",
                    "to" : "It's time",
                    "daymake" : "Compensatory work day",
                    "employee" : "Personnel need to create an application",
                    "total" : "Total hours",
                    "daycreator" : "Date created",
                    type: "Type",
                    timeMake: "Time Make"
                },
                "message": {
                    "add": "Successfully added late-to-early applications!",
                    "update": "Successfully correcting late arrival and early return!"
                },
                "placeholder": {
                    "employee": "Select the personnel to create the application"
                }
            }
        },
        "name": {
            "inout": "Check in check out",
            "flexible": "Flexible",
            "resign": "Resign",
            "shift swap": "Shift change",
            "missions": "Mission",
            "overtime": "Over time",
            "absence": "Absence",
            "leave": "Leave",
            "shift more": "Shift more",
            "shift registration": "Shift registration",
            "late" : "Late"
        }
    }
}